var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderCartClosedBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 86,
    viewBox: "0 0 276 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -20H276V106H0V-20Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.929 -28.8334C210.829 -28.8334 179.167 2.89996 179.167 42C179.167 81.1 210.829 112.833 249.929 112.833C289.1 112.833 320.833 81.1 320.833 42C320.833 2.89996 289.1 -28.8334 249.929 -28.8334ZM250 98.6666C218.692 98.6666 193.333 73.3083 193.333 42C193.333 10.6916 218.692 -14.6667 250 -14.6667C281.308 -14.6667 306.667 10.6916 306.667 42C306.667 73.3083 281.308 98.6666 250 98.6666Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.542 6.58337H242.917V49.0834L280.104 71.3959L285.417 62.6834L253.542 43.7709V6.58337Z",
    fill: "#767676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 276,
    height: 126,
    fill: "white",
    transform: "translate(0 -20)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCartClosedBg);
export default __webpack_public_path__ + "static/media/headerCartClosedBg.906e5bdd62b16044cc7884012b57a5c0.svg";
export { ForwardRef as ReactComponent };